import Image from "next/image";

import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

export const Contact = () => {
  const i18n = useI18n();

  return (
    <div className="flex overflow-hidden justify-center items-center px-3 mb-14 max-h-[300px] bg-yellow rounded-xl lg:justify-between lg:pr-0 lg:pl-[92px]">
      <div className="py-20 text-center lg:text-left">
        <h2 className="mb-2 text-2xl font-bold lg:mb-0 lg:text-3xl">
          {i18n.t("paymentMethods.contact.title")}
        </h2>

        <p className="mb-8 text-base font-normal lg:text-2xl lg:font-normal">
          {i18n.t("paymentMethods.contact.description")}
        </p>

        <a href="mailto:hello@mobile.club">
          <Button className="bg-white">
            {i18n.t("paymentMethods.contact.button")}
          </Button>
        </a>
      </div>

      <div className="hidden relative w-1/2 h-[300px] lg:block">
        <Image
          layout="fill"
          src="/images/seo/modes-de-paiement/contact.webp"
          alt="Payment method contact"
          className="object-cover object-center ml-4 w-full h-full"
        />
      </div>
    </div>
  );
};
